module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-end gerenciador-presenca-container",
    class: _vm.podeEditar ? 'edicao-permitida' : 'edicao-nao-permitida'
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', [_vm._v("Gerenciador de Edição da Proposta [ " + _vm._s(_vm.numeroProposta) + " ]")])]), _vm._v(" "), (Object.keys(_vm.sessaoAtiva).length > 0) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.sessaoAtiva.user_name == _vm.usuarioLogado.ds_nome_usuario && !_vm.podeEditar ? 'Você já está editando em outra aba ou navegador' : 'Editando agora: ' + _vm.sessaoAtiva.user_name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.podeEditar) ? _c('div', [_vm._v("\n        Última Atualização de Presença: "), _c('b', [_vm._v(_vm._s(_vm.moment(_vm.sessaoAtiva.ultimo_ping).format('DD/MM/YYYY HH:mm:ss')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c11259c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/GerenciadorEdicaoProposta.vue
// module id = 2073
// module chunks = 1